import React from 'react';
import BtnClose from '../Button/BtnClose';

export default function WarningAlert({ text, onClose }) {
  if (onClose) {
    return (
      <div className="alert-warning alert"><BtnClose onClick={onClose} /> {text}</div>
    );
  }
  return (
    <div className="alert-warning alert">{text}</div>
  );
}
